/**
 * Links to Explore pages
 */

// grab the correct routing function out of explore page
import columnFunction from 'clientPages/explore/pages/columns/getExploreState'
import tableFunction from 'clientPages/explore/pages/table/getExploreState'

import React, { useContext } from 'react'
import BasicLink from '../BasicLink'
import { ConfigContext } from 'components/context/ConfigProvider'
import qs from 'qs'

export interface ExploreLinkFields {
  [field: string]: string[]
}
interface ExploreLinkProps {
  fields: ExploreLinkFields
  openInNewTab?: boolean
  className?: string
  children: React.ReactNode
}

const ExploreLink = ({
  fields,
  openInNewTab = false,
  className,
  children,
}: ExploreLinkProps): JSX.Element => {
  // get config
  const config = useContext(ConfigContext)
  if (!config) {
    throw new Error('Config is null or undefined from ConfigContext.')
  }

  // get pageSrc of Explore page
  const pageSrc = config.siteMap.explore._pageSrc
  // page src should exist, throw error if not
  if (!pageSrc) {
    throw new Error(`Page src not found in sitemap for explore page.`)
  }

  // grab which explore page is defined in sitemap, eg "columns" or "table"
  const explorePage = pageSrc.split('/').at(-1)

  const exploreState =
    explorePage === 'table'
      ? tableFunction(fields)
      : explorePage === 'columns'
      ? columnFunction(fields)
      : {}

  return (
    <BasicLink
      className={className}
      openInNewTab={openInNewTab}
      url={config.siteMap.explore.url + '?' + qs.stringify(exploreState)}
    >
      {children}
    </BasicLink>
  )
}
export default ExploreLink
